<template>
	<div style="text-align: center;background-color: #EBEEF5;">
		<div class="sameWidth">
			<el-breadcrumb separator-class="el-icon-arrow-right" style="padding:20px 20px;">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/tenderInfo' }">招标信息</el-breadcrumb-item>
				<el-breadcrumb-item>招标详情</el-breadcrumb-item>
			</el-breadcrumb>
			<div style="text-align: left;padding:40px;margin:10px;background-color: #fff;">
				<div>
					<div id="tenderDiv">
						<h3>{{tenderInfo.title}}</h3>
						<p>
							<span>项目编号：{{tenderInfo.projectSn}}</span>
							<span>招标方式：{{tenderInfo.bidMethodName}}</span>
						</p>
						<p>
							<span>发布时间：{{tenderInfo.publishDate}}</span>
							<span>报名截止时间：{{tenderInfo.deadlineDate}}</span>
						</p>
						<el-divider></el-divider>
					</div>
					<div v-html="tenderInfo.content" id="wangTable">
					</div>
					<div style="margin-top:50px;">
						<p v-for="(item,index) in tenderInfo.fileList" :key="index" style="margin:5px 0;">
							<span>附件下载：</span>
              <span style="cursor:pointer;color: #0D81D6;" @click="loadFile(item.url,item.fileName)">{{item.fileName}}</span>
						</p>

					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<style>
	#wangTable img{max-width: 100%;}
	#wangTable table{
		width:100%;
		border-top:#DCDFE6 1px solid;
		border-left:#DCDFE6 1px solid;
	}
	#wangTable table td,#wangTable table th{
		border-bottom:#DCDFE6 1px solid;
		border-right:#DCDFE6 1px solid;
		padding: 10px;
		height: 25px;
		line-height: 25px;
	}
</style>
<script>
export default {
	name:'tenderInfoContent',
	data() {
		return {
			screenWidth:1300,
			tenderInfo:{
				number:'',
				way:0,
				release_time:'',
				end_time:'',
				content:''
			}
		}
	},
	methods: {
    loadFile(path,name) {
      return window.open(path,'_blank');
    }
  },
	mounted:function(){
			this.bus.$emit('headerImg',[{src:require('@/assets/images/bk/招标信息.jpg'),href:""}])
			var that=this;
			let tenderId = this.$route.query.id;
			this.$axios.get(this.baseUrl4+'bidNotice/'+tenderId).then(response=>{
				if(response.data.code!='200'){
					that.$alert(response.data.msg, '提示', {confirmButtonText: '确定'});
				}else{
          Object.assign(this.tenderInfo,response.data.data)
				}
			}).catch(function (error) {window.console.log(error)});//ajax请求失败

			this.screenWidth=document.documentElement.clientWidth;
			window.addEventListener('resize',()=>{
				this.screenWidth=document.documentElement.clientWidth;
			})
	},
	beforeDestroy () {
		localStorage.removeItem('tempData')
	}
}
</script>

<style scoped>
	#tenderDiv{
		border-radius: 5px;margin-top: 20px;
	}
	#tenderDiv span{display: inline-block;width: 400px;}
</style>
